(() => {
  const bar = document.querySelector('[data-cc-preorder-shortcut]');
  const hero = document.querySelector('.cc-hero');
  const finalAction = document.querySelector('.cc-cta');
  if (!bar || !hero || !finalAction || !('IntersectionObserver' in window)) return;
  let heroVisible = true;
  let finalVisible = false;
  const mobile = window.matchMedia('(max-width: 749px)');
  const update = () => {
    const show = mobile.matches && !heroVisible && !finalVisible;
    // Avoid hiding a link while someone is using it with the keyboard.
    if (!show && bar.contains(document.activeElement)) return;
    bar.hidden = !show;
    document.body.classList.toggle('cc-shortcut-visible', show);
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === hero) heroVisible = entry.isIntersecting;
      if (entry.target === finalAction) finalVisible = entry.isIntersecting;
    });
    update();
  });
  observer.observe(hero);
  observer.observe(finalAction);
  mobile.addEventListener('change', update);
  bar.addEventListener('focusout', () => requestAnimationFrame(update));
  update();
})();
